import { Link } from "@/i18n/routing";
import {
  AddToCartButton,
  BadgeDiscount,
  ToggleWishlistButton,
} from "@repo/components";
import { formProductUrl } from "@repo/lib/helpers";
import { hasDiscount } from "@repo/lib/utils";
import { Media, ProductPrice } from "@repo/ui";

const ProductCard = ({
  product,
  wishlistItems,
  session,
  collectionName,
  categorySlug,
  spaceSlug,
  handleCloseMiniCart,
}) => {
  const {
    discount,
    slug: productSlug,
    name,
    image,
    id,
    price,
    formattedPrice,
    formattedSalePrice,
    isStockStatus,
  } = product;

  const productUrl = formProductUrl(
    collectionName,
    categorySlug,
    spaceSlug,
    productSlug //product slug
  );

  const discounted = hasDiscount(discount);

  return (
    <div className="relative">
      <Link href={`/${productUrl}`} onClick={handleCloseMiniCart}>
        <Media
          src={image?.imageURI}
          alt={collectionName === "category" ? `${name}-${categorySlug}` : name}
        />
        <h2 className="text-listCardTitle mb-3 mt-2 line-clamp-2 h-9 text-xs font-semibold md:h-12 md:text-base md:font-medium rtl:h-[34px] rtl:md:h-12">
          {name}
        </h2>
      </Link>

      {discounted && <BadgeDiscount discount={discount} variant="sm" />}

      <ToggleWishlistButton
        productId={id}
        variant="sm"
        items={wishlistItems}
        session={session}
        product={product}
      />

      <div className="md:flex md:items-center">
        <ProductPrice
          price={formattedPrice || price}
          salePrice={formattedSalePrice}
          discount={discount}
          variant="card"
        />
        <span className="ms-auto">
          <AddToCartButton
            product={product}
            isInStock={isStockStatus}
            variant="primary"
            categorySlug={categorySlug}
            spaceSlug={spaceSlug}
          />
        </span>
      </div>
    </div>
  );
};

export default ProductCard;
